export { LegacyComponentLog } from './legacy-component-log';
